import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ProductCountExpressionChange =
  ProjectChangeMap[ProjectChangeType.ProductElementCountExpression];

/**
 * Build a partial element change for ProductElementCountExpression.
 *
 * @param element - Current element state
 * @param change - Expression payload
 * @returns Partial<OneOfElements> or undefined
 */
export const productElementCountExpressionToChange = (
  element: OneOfElements,
  change: ProductCountExpressionChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.productElement(element)) return undefined;
  if (!element.count) return undefined;
  if (element.count.expression === change.expression) return undefined;

  return {
    count: { ...element.count, expression: change.expression },
  };
};
